import { useEffect } from 'react';

/**
 * Custom hook to set the page title dynamically
 * @param pageTitle - The title to display in the browser tab. If null/undefined, defaults to "ArcSite"
 * @param suffix - The suffix to append to the title. Defaults to "ArcSite". Pass empty string to show only pageTitle
 * @example
 * // Default usage with ArcSite suffix
 * usePageTitle('Projects');
 * // Result: "Projects | ArcSite"
 *
 * @example
 * // Custom suffix (e.g., project name)
 * usePageTitle('My Drawing', 'My Project Name');
 * // Result: "My Drawing | My Project Name"
 *
 * @example
 * // No suffix
 * usePageTitle('Standalone Page', '');
 * // Result: "Standalone Page"
 */
export function usePageTitle(
  pageTitle: string | undefined,
  suffix: string = 'ArcSite'
) {
  useEffect(() => {
    const originalTitle = document.title;
    if (pageTitle) {
      document.title = suffix !== '' ? `${pageTitle} | ${suffix}` : pageTitle;
    }

    return () => {
      document.title = originalTitle;
    };
  }, [pageTitle, suffix]);
}
